import UserPicker from './UserPicker.vue'

export default UserPicker